import { render } from "./editExpense.vue?vue&type=template&id=a95a0eae&scoped=true"
import script from "./editExpense.vue?vue&type=script&lang=js"
export * from "./editExpense.vue?vue&type=script&lang=js"

import "./editExpense.vue?vue&type=style&index=0&id=a95a0eae&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95a0eae"]])

export default __exports__